import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ChartWrapper } from "./chart.style";

import("highcharts/modules/accessibility");
import("highcharts/modules/exporting");
import("highcharts/modules/offline-exporting");
import("highcharts/modules/export-data");

const Chart = ({ data, ...chartContainerProps }) => {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const dat = {
      ...data,
      tooltip: {
        ...data.tooltip,
        pointFormatter: new Function(data.tooltip.pointFormatter),
      },
    };
    setOptions(dat);
  }, [data]);

  return (
    <ChartWrapper>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        containerProps={{ ...chartContainerProps }}
      />
    </ChartWrapper>
  );
};

export default Chart;
